<template>
  <div
    class="atom-input-errors has-error"
    :class="{
      'is-extended': isExtended,
      'is-checkbox': isCheckbox,
      'is-options': isOptions,
    }"
  >
    <div class="atom-input-errors__icon">
      <IonIcon
        icon-name="information-circle"
        icon-size="22px"
        icon-color="var(--c-error)"
      />
    </div>
    <ul class="atom-input-errors__list">
      <span class="atom-input-errors__triangle" />
      <li
        v-for="(error, index) in errors"
        :key="index"
        class="atom-input-errors__message"
      >
        {{ error }}
      </li>
    </ul>
  </div>
</template>

<script setup>

defineProps({
    errors: {
        type: Array,
        default: () => [],
        validator: (value) => Array.isArray(value),
    },

    isExtended: {
        type: Boolean,
        default: false,
    },

    isCheckbox: {
        type: Boolean,
        default: false,
    },

    isOptions: {
        type: Boolean,
        default: false,
    },
});
</script>

<style lang="scss" scoped>
.atom-input-errors {
    position: relative;
    position: absolute;
    z-index: 1000;

    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    pointer-events: none;
    row-gap: 10px;

    &.is-options {
        top: unset;
        bottom: -22px;
    }

    &.is-checkbox  {
        top: -12px;
    }
}

.atom-input-errors__list {
    position: absolute;
    top: 55px;
    display: flex;
    width: 100%;
    flex-direction: column;
    padding: 10px;
    border-radius: var(--b-radius--full);
    background: var(--c-error);
    color: var(--c-white);
    font-family: var(--f-family--primary);
    font-size: 13px;
    font-weight: var(--f-weight--500);
    line-height: 17px;
    opacity: 0;
    row-gap: 10px;
    transition: opacity 0.2s ease-in-out;

    .is-extended & {
        opacity: 1;
    }
}
.atom-input-errors__message {
    position: relative;
    padding-left: 15px;

    // &:before {
    //     position: absolute;
    //     top: 0;
    //     left: 15px;
    //     width: 3px;
    //     height: 3px;
    //     border-radius: 50%;
    //     margin-top: calc(17px / 2);
    //     background: var(--c-white);
    //     content: '';
    //     transform: translateY(-50%);
    // }
}

.atom-input-errors__triangle {
    @include fluid-simple('right', 40px, 40px);

    position: absolute;
    top: 2px;
    width: 18px;
    height: 18px;
    border-radius: 2px;
    background: var(--c-error);
    transform: rotate(45deg) translateY(-50%) translateY(-2px);
}

.atom-input-errors__icon {
    @include fluid-simple('right', 31px, 31px);

    position: absolute;
    top: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.4s var(--ease-in-out--back);

    .atom-input-toggle__wrapper & {
        top: 0px;
    }
}
</style>
